import { ApiExError } from '@shared';
import { initialState } from './initialState';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface PartnerPolicyApplicationState {
  applications: ClientPolicyApplication[];
  status: PolicyApplicationModelStatus;
  error: string | null;
}

const partnerPolicyApplicationModelSlice = createSlice({
  name: 'partnerPolicyApplicationModel',
  initialState: initialState.partnerPolicyApplicationModel,
  reducers: {
    fetchPolicyApplicationsByPartnerClientIdForAdvisorRequest(
      state,
      action: PayloadAction<{ partnerClientId: string }>,
    ) {
      state.status = 'fetching';
      state.error = null;
    },
    fetchPolicyApplicationsByPartnerClientIdForAdvisorResponse(
      state,
      action: PayloadAction<ClientPolicyApplication[]>,
    ) {
      state.status = 'fetchingComplete';
      state.error = null;
      state.applications = action.payload || [];
    },
    fetchPolicyApplicationsByPartnerClientIdForAdvisorFailure(
      state,
      action: PayloadAction<ApiExError>,
    ) {
      state.status = 'error';
      state.error =
        action.payload?.message ||
        'Failed to fetch partner policy applications';
    },
  },
});

export const {
  fetchPolicyApplicationsByPartnerClientIdForAdvisorRequest,
  fetchPolicyApplicationsByPartnerClientIdForAdvisorResponse,
  fetchPolicyApplicationsByPartnerClientIdForAdvisorFailure,
} = partnerPolicyApplicationModelSlice.actions;

export const partnerPolicyApplicationModelReducer =
  partnerPolicyApplicationModelSlice.reducer;
